(() => {
  if (window.elaraCroImagesReady) return;
  window.elaraCroImagesReady = true;
  const dialog = document.getElementById('elara-cro-image-dialog');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  let returnFocus = null;
  const enhance = root => {
    root.querySelectorAll('.elara-desc img, .elara-social-proof__image').forEach(img => {
      if (img.closest('a, button') || !img.getAttribute('src')) return;
      img.dataset.elaraZoom = '';
      img.tabIndex = 0;
      img.setAttribute('role', 'button');
      const label = dialog.dataset.enlargeLabel || '';
      img.setAttribute('aria-label', img.alt ? `${label}: ${img.alt}` : label);
    });
  };
  const open = img => {
    const source = new URL(img.currentSrc || img.src, document.baseURI);
    source.searchParams.delete('width');
    const full = dialog.querySelector('[data-elara-full-image]');
    full.src = source.href;
    full.alt = img.alt || '';
    dialog.querySelector('[data-elara-original-image]').href = source.href;
    returnFocus = img;
    if (!dialog.open) dialog.showModal();
  };
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const img = event.target.closest('img[data-elara-zoom]');
    if (img) { open(img); return; }
    if (event.target.closest('[data-elara-dialog-close]')) dialog.close();
    if (event.target === dialog) {
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    }
  });
  document.addEventListener('keydown', event => {
    if (!['Enter', ' '].includes(event.key) || !(event.target instanceof Element) || !event.target.matches('img[data-elara-zoom]')) return;
    event.preventDefault();
    open(event.target);
  });
  dialog.addEventListener('close', () => {
    dialog.querySelector('[data-elara-full-image]').removeAttribute('src');
    if (returnFocus?.isConnected) returnFocus.focus();
  });
  enhance(document);
  document.addEventListener('shopify:section:load', event => enhance(event.target));
})();
